import { Box } from "@material-ui/core";
import React from "react";

interface TabPanelProps {
	children?: React.ReactNode;
	index: string;
	value: string;
}

export function GridTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;
	const [inited, setInited] = React.useState(false);

	React.useEffect(() => {
		if (value === index)
			setInited(true)
	});

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{inited && (
				<Box p={3} style={{ display: value === index ? 'block' : 'none' }}>
					{children}
				</Box>
			)}
		</div>
	);
}
